import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import DeferredInvoicesPage from './DeferredInvoicesPage';
import './DeferredInvoicesPage.less';

export const prefix = 'bm-p-deferred-invoices';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: DeferredInvoicesPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
